export default "__VITE_ASSET__C7Orv3Ij__"